import React from "react";
import arrow from "../assets/images/sidom/fotos/FlechaenCirc4.png"; // Adjust the path as necessary

export default function CardBeneficios({
  titulo,
  descripcion,
  backgroundColor,
  textcolor,
}) {
  return (
    <div>
      <div className="  flex items-center     justify-center">
        <div className={` container ${backgroundColor} ${textcolor} `}>
          <div className=" flex items-start  w-full px-2 md:px-0 lg:px-0 dark:text-sidom-light  justify-start  gap-2">
            <div className=" h-full  ">
              <div className="flex-shrink-0 w-10 h-10  bg-sidom-orange rounded-full flex items-start  justify-center">
                <img src={arrow} alt="Flecha" />
              </div>
            </div>

            <div className="   w-full text-wrap lg:text-nowrap ">
              <h1 className=" text-2xl md:text-3xl lg:text-3xl   font-bold ">
                {titulo}
              </h1>
            </div>
          </div>
          <div className=" flex items-center  leading-[1.3] mb-[30px]   justify-end   gap-2">
            <p className=" text-base  pr-10 w-[80%] md:w-[90%]   mt-2">
              {descripcion}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
